"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const apollo_client_1 = require("apollo-client");
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
const apollo_link_http_1 = require("apollo-link-http");
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const constants_1 = require("../constants");
const queries_1 = require("./queries");
const parseToken = (token) => (Object.assign(Object.assign({}, token), { decimals: +token.decimals, priceUSD: +token.priceUSD }));
const parsePoolToken = (_a) => {
    var { token } = _a, rest = __rest(_a, ["token"]);
    return (Object.assign(Object.assign({}, rest), { token: parseToken(token) }));
};
const parseDailySnapshot = (_a) => {
    var { date, value, feesTotalUSD, totalValueLockedUSD, totalSwapVolumeUSD, totalVolumeUSD, dailyFeesUSD, dailySwapVolumeUSD } = _a, rest = __rest(_a, ["date", "value", "feesTotalUSD", "totalValueLockedUSD", "totalSwapVolumeUSD", "totalVolumeUSD", "dailyFeesUSD", "dailySwapVolumeUSD"]);
    return (Object.assign(Object.assign({}, rest), { date: +date, value: +value, feesTotalUSD: +feesTotalUSD, totalValueLockedUSD: +totalValueLockedUSD, totalSwapVolumeUSD: +totalSwapVolumeUSD, totalVolumeUSD: +totalVolumeUSD, dailyFeesUSD: +dailyFeesUSD, dailySwapVolumeUSD: +dailySwapVolumeUSD }));
};
const parsePool = (_a) => {
    var { size, swapFee, exitFee, feesTotalUSD, totalValueLockedUSD, totalVolumeUSD, totalSwapVolumeUSD, dailySnapshots, tokens, poolInitializer } = _a, rest = __rest(_a, ["size", "swapFee", "exitFee", "feesTotalUSD", "totalValueLockedUSD", "totalVolumeUSD", "totalSwapVolumeUSD", "dailySnapshots", "tokens", "poolInitializer"]);
    return (Object.assign(Object.assign({}, rest), { size: +size, swapFee: +swapFee, exitFee: +exitFee, feesTotalUSD: +feesTotalUSD, totalValueLockedUSD: +totalValueLockedUSD, totalVolumeUSD: +totalVolumeUSD, totalSwapVolumeUSD: +totalSwapVolumeUSD, poolInitializer: Object.assign(Object.assign({}, poolInitializer), { tokens: poolInitializer.tokens.map((_a) => {
                var { token } = _a, tokenRest = __rest(_a, ["token"]);
                return (Object.assign(Object.assign({}, tokenRest), { token: parseToken(token) }));
            }) }), tokens: tokens.map(parsePoolToken), dailySnapshots: dailySnapshots.map(parseDailySnapshot) }));
};
const parseStakingPool = (_a) => {
    var { startsAt, periodFinish, lastUpdateTime } = _a, rest = __rest(_a, ["startsAt", "periodFinish", "lastUpdateTime"]);
    return (Object.assign(Object.assign({}, rest), { startsAt: +startsAt, periodFinish: +periodFinish, lastUpdateTime: +lastUpdateTime }));
};
class IndexedCoreSubgraphClient {
    constructor(client) {
        this.client = client;
    }
    static forNetwork(network) {
        const client = new apollo_client_1.ApolloClient({
            link: new apollo_link_http_1.HttpLink({ uri: constants_1.SUBGRAPH_URLS[network].indexedCore, fetch: isomorphic_fetch_1.default }),
            cache: new apollo_cache_inmemory_1.InMemoryCache(),
            shouldBatch: true,
        });
        return new IndexedCoreSubgraphClient(client);
    }
    // Index Pools
    getIndexPool(poolId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.query({
                query: queries_1.POOL_BY_ID,
                variables: { poolId: poolId.toLowerCase() },
                fetchPolicy: 'cache-first'
            }).then((result) => parsePool(result.data.indexPool));
        });
    }
    getAllIndexPools() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.query({
                query: queries_1.ALL_POOLS,
                fetchPolicy: 'cache-first'
            }).then((result) => result.data.indexPools.map(parsePool));
        });
    }
    getPoolUpdate(poolId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.query({
                query: queries_1.POOL_UPDATE,
                variables: { poolId: poolId.toLowerCase() },
                fetchPolicy: 'cache-first'
            }).then((result) => {
                const { dailySnapshots, tokens } = result.data.indexPool;
                const snapshot = parseDailySnapshot(dailySnapshots[0]);
                const tokenPrices = tokens.reduce((obj, t) => (Object.assign(Object.assign({}, obj), { [t.token.id]: +(t.token.priceUSD) })), {});
                return { snapshot, tokenPrices };
            });
        });
    }
    getPoolSnapshots(poolId, hours) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.query({
                query: queries_1.POOL_SNAPSHOTS,
                variables: {
                    poolId: poolId.toLowerCase(),
                    hours
                },
                fetchPolicy: 'cache-first'
            }).then((result) => result.data.indexPool.dailySnapshots.map(parseDailySnapshot));
        });
    }
    // Staking Pools
    getAllStakingPools() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.query({
                query: queries_1.STAKING_POOLS,
                fetchPolicy: 'cache-first'
            }).then((result) => result.data.ndxStakingPools.map(parseStakingPool));
        });
    }
}
exports.default = IndexedCoreSubgraphClient;
